export default __webpack_public_path__ + "static/media/icon_recommend-product-hover.81b1a155.svg";